import apiClient from '../authentication/utils/core/axios';

/**
 * TeamMeetingsAPI — admin-only archive of team meeting recordings,
 * transcribed + diarized offline (never on this server -- no GPU) and
 * uploaded here after the fact. Mirrors StatusMapAPI/RoadmapAPI's shape.
 */
const TeamMeetingsAPI = {
  fetchMeetings: async () => {
    const res = await apiClient.get('/admin/team-meetings/', { timeout: 30000 });
    return res.data;
  },

  fetchMeeting: async (meetingId) => {
    const res = await apiClient.get(`/admin/team-meetings/${meetingId}`);
    return res.data;
  },

  createMeeting: async (meetingData) => {
    const res = await apiClient.post('/admin/team-meetings/', meetingData, { timeout: 30000 });
    return res.data;
  },

  updateMeeting: async (meetingId, updates) => {
    const res = await apiClient.patch(`/admin/team-meetings/${meetingId}`, updates);
    return res.data;
  },

  deleteMeeting: async (meetingId) => {
    await apiClient.delete(`/admin/team-meetings/${meetingId}`);
    return meetingId;
  },
};

export default TeamMeetingsAPI;
